/**
 * 对象是否有某个实例属性
 * @param obj 对象
 * @param key 对象的属性
 */
export function hasOwn(
    obj: Record<string | number, any>,
    key: string
): boolean {
    return Object.prototype.hasOwnProperty.call(obj, key)
}
